import { ReactComponent as EmptyStateGraphic } from '@elementary/common-ui/assets/empty-state-cloud.svg';
import { FlexColumn, Link } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import styled from 'styled-components';
import { fontSize, fontWeight, space } from '@elementary/common-ui/style/utils';

const Wrapper = styled(FlexColumn)`
  background-color: ${({ theme }) => theme.palette.surface.soft};
  padding: ${space('lg', 'xxl')};
  gap: ${space('lg')};
  align-items: center;
  height: 100%;
  justify-content: center;
`;

const Text = styled(Typography)`
  text-align: center;
`;

type Props = {
  title?: string;
  description?: string;
  docsLink?: string;
};

const DependenciesEmptyState = ({
  title = 'No assets linked to this test',
  description = 'Connect this test to the relevant asset to view its dependencies.',
  docsLink,
}: Props) => (
  <Wrapper>
    <EmptyStateGraphic width="57px" />
    <Typography
      sx={{ fontWeight: fontWeight('medium'), fontSize: fontSize('lg') }}
    >
      {title}
    </Typography>
    <Text>
      {description}
      {docsLink && (
        <>
          {' '}
          <Link target="_blank" href={docsLink}>
            Learn more
          </Link>
        </>
      )}
    </Text>
  </Wrapper>
);

export default DependenciesEmptyState;
